import React from "react";
import { Helmet } from "react-helmet-async";

export default function Seo({
  title,
  description,
  canonical,
  image = "https://parishaudio.com/assets/og-default.jpg",
  imageAlt = "Parish Audio",
  ogType = "website",
  robots = "index,follow",
  schema = null,
}) {
  const businessSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "Parish Audio",
    url: "https://parishaudio.com",
    logo: "https://parishaudio.com/assets/logo.png",
    contactPoint: {
      "@type": "ContactPoint",
      email: "support@parishaudio.com",
      contactType: "customer support",
    },
  };

  const schemas = schema
    ? Array.isArray(schema)
      ? [businessSchema, ...schema]
      : [businessSchema, schema]
    : [businessSchema];

  return (
    <Helmet>
      <title>{title}</title>

      <meta name="description" content={description} />
      <meta name="robots" content={robots} />
      <link rel="canonical" href={canonical} />

      <meta property="og:type" content={ogType} />
      <meta property="og:site_name" content="Parish Audio" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={image} />
      <meta property="og:image:alt" content={imageAlt} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {schemas.map((item, index) => (
        <script key={index} type="application/ld+json">
          {JSON.stringify(item)}
        </script>
      ))}
    </Helmet>
  );
}

// import React from "react";

// export default function Seo({ title, description, canonical }) {
//   const jsonLd = {
//     "@context": "https://schema.org",
//     "@type": "ProfessionalService",
//     name: "Parish Audio",
//     url: "https://parishaudio.com",
//     areaServed: "Worldwide",
//     address: {
//       "@type": "PostalAddress",
//       addressLocality: "Burley",
//       addressRegion: "ID",
//       addressCountry: "US",
//     },
//     contactPoint: {
//       "@type": "ContactPoint",
//       email: "support@parishaudio.com",
//       contactType: "customer support",
//     },
//   };

//   return (
//     <>
//       <title>{title}</title>
//       <meta name="description" content={description} />
//       <link rel="canonical" href={canonical} />

//       {/* Open Graph */}
//       <meta property="og:type" content="website" />
//       <meta property="og:title" content={title} />
//       <meta property="og:description" content={description} />
//       <meta property="og:url" content={canonical} />

//       {/* Twitter */}
//       <meta name="twitter:card" content="summary_large_image" />
//       <meta name="twitter:title" content={title} />
//       <meta name="twitter:description" content={description} />

//       {/* Structured data */}
//       <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
//     </>
//   );
// }